import { render, staticRenderFns } from "./AssignmentDashboard.vue?vue&type=template&id=07c3adde&scoped=true&"
import script from "./AssignmentDashboard.vue?vue&type=script&lang=js&"
export * from "./AssignmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentDashboard.vue?vue&type=style&index=0&id=07c3adde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3adde",
  null
  
)

export default component.exports